import React from "react";

interface TextSubtitleProp {
  title: string;
  subtitle: string;
  key?: number;
}

const TextSubtitle = (prop: TextSubtitleProp) => {
  return (
    <div className="p-6 border rounded border-border">
      <div className="font-bold text-base text-center text-text-primary">
        {prop.title}
      </div>
      <div className="mt-6 text-sm whitespace-pre-line text-text-secondary">
        {prop.subtitle}
      </div>
    </div>
  );
};

export default TextSubtitle;
